import update from 'immutability-helper';
import eventApi from '../lib/api/event';
import { syncVolatileAvailability } from './eventPageReducer';
// ------------------------------------
// Constants
// ------------------------------------

export const RECEIVE_EVENT = 'EVENT/LOAD_SUCCESS';
export const LOAD_EVENT = 'EVENT/LOADING';
export const EVENT_ERROR = 'EVENT/ERROR';
export const SELECT_EVENT = 'SELECT_EVENT';

export function receiveEvent(event) {
	return {
		type: RECEIVE_EVENT,
		event,
	};
}

export function selectEvent(uuid) {
	return {
		type: SELECT_EVENT,
		uuid,
	};
}

export function startLoading() {
	return {
		type: LOAD_EVENT,
	};
}

export function error(message) {
	return {
		type: EVENT_ERROR,
		message,
	};
}

export function fetchEvent(uuid) {
	return async (dispatch, getState) => {
		dispatch(startLoading());
		try {
			const event = await eventApi.getEvent(
				getState().merchant.merchantId,
				getState().merchant.themeName, uuid
			);
			dispatch(receiveEvent(event));
		} catch (e) {
			console.info('could not load event', e.messageDe);
			if ((e.domainObject === 'Event') && (e.statusCode === 'FORBIDDEN')) {
				throw e;
			}
			dispatch(error(e.messageDe));
		}
	};
}

export function refreshEvent() {
	return async (dispatch, getState) => {
		await dispatch(fetchEvent(getState().event.selected));
		dispatch(syncVolatileAvailability(getState().event.elements[getState().event.selected].categories));
	};
}

export function fetchEventIfNeeded(uuid) {
	return (dispatch, getState) => {
		if (!getState().event.elements[uuid]) {
			return dispatch(fetchEvent(uuid));
		}
		return Promise.resolve();
	};
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
	[RECEIVE_EVENT]: (state, action) => update(state, {
		elements: {
			[action.event.uuid]: { $set: action.event },
		},
		isLoading: { $set: false },
	}),
	[SELECT_EVENT]: (state, action) => update(state, {
		selected: { $set: action.uuid },
	}),
	[LOAD_EVENT]: (state) => update(state, {
		isLoading: { $set: true },
	}),
	[EVENT_ERROR]: (state, action) => update(state, {
		isLoading: { $set: false },
		error: { $set: action.message },
	}),
};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
	elements: {},
	selected: null,
	isLoading: false,
	error: null,
};

export default function reducerFunction(state = initialState, action) {
	const handler = ACTION_HANDLERS[action.type];
	return handler ? handler(state, action) : state;
}
